import React, { useState, useRef } from "react";
import {
  AppBar,
  Typography,
  Button,
  IconButton,
  Box,
  Collapse,
  useMediaQuery,
  Popper,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Grow,
  ListItemIcon,
  Grid,
  Stack,
  Badge,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Person, Search } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useNavigationFunctions } from "../CustomHook";
import templeJson from "../../../../config/temple.json";

const TempleNavbar = () => {
  const {
    devoteeData,
    hasToken,
    totalCartCount,
    currentUrlPath,
    handleLogout,
    handleCartClick,
  } = useNavigationFunctions();

  const [navExpanded, setNavExpanded] = useState(false);
  const isLgDown = useMediaQuery("(max-width: 1200px)");
  const menuItems = templeJson["Header"].menuItems;

  const toggleNavExpanded = () => {
    setNavExpanded(!navExpanded);
  };

  // Unified SubDropdown component for both mobile and desktop
  const SubDropdown = ({ item, mobile = false, onClose }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleToggle = () => {
      setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }
      setOpen(false);
    };

    const handleParentClose = (event) => {
      handleClose(event);
      if (onClose) onClose(event);
    };

    // Mobile version uses Collapse
    if (mobile) {
      return (
        <Box sx={{ width: "100%" }}>
          <Button
            fullWidth
            color="inherit"
            onClick={handleToggle}
            endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            className="mobile-subdropdown-button"
          >
            {item.name}
          </Button>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box className="mobile-subdropdown-container">
              {item.items.map((subItem, idx) => (
                <Button
                  key={idx}
                  fullWidth
                  color="inherit"
                  href={subItem.url}
                  className="mobile-subdropdown-item"
                >
                  {subItem.name}
                </Button>
              ))}
            </Box>
          </Collapse>
        </Box>
      );
    } else {
      // Desktop version uses Popper
      return (
        <Box onMouseEnter={handleToggle} onMouseLeave={handleClose}>
          <MenuItem
            ref={anchorRef}
            aria-haspopup="true"
            className="desktop-submenu-item"
          >
            {item.name}
            <ListItemIcon sx={{ marginLeft: "auto" }}>
              <KeyboardArrowRightIcon fontSize="small" />
            </ListItemIcon>
          </MenuItem>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="right-start"
            transition
            disablePortal
            sx={{ zIndex: 1300 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "right-start" ? "left top" : "left bottom",
                }}
              >
                <Paper elevation={3} sx={{ minWidth: 180 }}>
                  <MenuList autoFocusItem={open}>
                    {item.items.map((subItem, idx) => (
                      <MenuItem
                        key={idx}
                        onClick={handleParentClose}
                        component="a"
                        href={subItem.url}
                        className="desktop-subdropdown-item"
                      >
                        {subItem.name}
                      </MenuItem>
                    ))}
                  </MenuList>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      );
    }
  };

  const loginOptions = [
    {
      name: devoteeData?.first_name,
      type: "dropdown",
      items: [
        {
          name: "Dashboard",
          url: `${process.env.REACT_APP_ADMIN_API_URL}`,
        },
        {
          name: "Profile",
          url: "/profile",
        },
        {
          name: "Change Password",
          url: "/changepassword",
        },

        {
          name: "Donation Report",
          url: "/report",
        },
        {
          name: "Logout",
          url: "/priests",
        },
      ],
    },
  ];

  // Component for navigation items
  const NavItem = ({ login = false, item, mobile = false }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleToggle = () => {
      setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }
      setOpen(false);
    };

    if (item.type === "link") {
      return (
        <Button
          color="inherit"
          href={item.url}
          fullWidth={mobile}
          className={mobile ? "mobile-nav-link" : "desktop-nav-link"}
        >
          {item.name}
        </Button>
      );
    } else if (item.type === "dropdown") {
      if (mobile) {
        return (
          console.log(item),
          (
            <Box sx={{ width: "100%" }}>
              <Button
                fullWidth
                color="inherit"
                onClick={handleToggle}
                endIcon={
                  open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />
                }
                className="mobile-dropdown-button"
              >
                {login && item?.name === devoteeData?.first_name ? (
                  <Tooltip title={item?.name}>
                    <Typography
                      sx={{
                        fontSize: "20% !important",
                        padding: "0 10px",
                        textOverflow: "unset",
                        textAlign: "center",
                      }}
                    >
                      {item.name}
                    </Typography>
                  </Tooltip>
                ) : (
                  item.name
                )}
              </Button>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box className="mobile-dropdown-container">
                  {item.items.map((subItem, idx) =>
                    subItem.type === "sub-Dropdown" ? (
                      <SubDropdown key={idx} item={subItem} mobile={true} />
                    ) : (
                      <Button
                        key={idx}
                        fullWidth
                        color="inherit"
                        href={subItem.url}
                        className="mobile-dropdown-item"
                      >
                        {subItem.name}
                      </Button>
                    )
                  )}
                </Box>
              </Collapse>
            </Box>
          )
        );
      } else {
        return (
          <Box>
            <Button
              ref={anchorRef}
              color="inherit"
              onClick={handleToggle}
              className="desktop-dropdown-button"
              sx={{
                "& .css-1d6wzja-MuiButton-startIcon": {
                  marginRight: "0 !important",
                },
                "& .css-6xugel": { marginRight: "0 !important" },
              }}
              startIcon={login == true && <Person fontSize="12px"></Person>}
            >
              {login && item?.name === devoteeData?.first_name ? (
                <Tooltip title={item?.name}>
                  <Typography
                    noWrap
                    sx={{
                      fontSize: "80% !important",
                      padding: "0 3px",
                      paddingTop: "3px",
                      textOverflow: "unset",
                    }}
                  >
                    {item.name}
                  </Typography>
                </Tooltip>
              ) : (
                item.name
              )}
            </Button>
            <Popper
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              placement="bottom-start"
              transition
              disablePortal
              sx={{ zIndex: 1300 }}
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom-start" ? "left top" : "left bottom",
                  }}
                >
                  <Paper elevation={3} sx={{ minWidth: 200 }}>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList autoFocusItem={open}>
                        {item.items.map((subItem, idx) =>
                          subItem.type === "sub-Dropdown" ? (
                            <SubDropdown
                              key={idx}
                              item={subItem}
                              mobile={false}
                              onClose={handleClose}
                            />
                          ) : (
                            <MenuItem
                              key={idx}
                              onClick={(e) => {
                                if (subItem.name == "Logout") {
                                  handleLogout();
                                  handleClose(e);
                                } else {
                                  handleClose(e);
                                }
                              }}
                              component="a"
                              href={subItem.name == "Logout" ? "" : subItem.url}
                              className="desktop-dropdown-item"
                            >
                              {subItem.name}
                            </MenuItem>
                          )
                        )}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>
        );
      }
    }
    return null;
  };

  return (
    <AppBar
      position="static"
      color="default"
      elevation={2}
      sx={{ overflow: "hidden" }}
    >
      <Grid container className="d-flex align-items-center nav-container">
        <Grid
          item
          xs={2}
          sm={2}
          md={2}
          lg={2}
          className="d-flex justify-content-center "
        >
          {isLgDown ? (
            <IconButton
              color="inherit"
              aria-label="toggle navigation"
              onClick={toggleNavExpanded}
              edge="end"
              className="nav-toggle"
            >
              <MenuIcon />
            </IconButton>
          ) : (
            templeJson["Header"].style == 1 && (
              <img
                src={"https://durgatemple.org/images/logo.png"}
                alt="logo"
                style={{ height: "60px", width: "70%", paddingBottom: "10px" }}
              />
            )
          )}
        </Grid>

        <Grid item xs={6} sm={6} md={7} lg={7}>
          {!isLgDown ? (
            <Box className="d-flex justify-content-center align-items-center">
              {menuItems.map((item, idx) => (
                <NavItem key={idx} item={item} />
              ))}
            </Box>
          ) : (
            <Box
              className="d-flex justify-content-center align-items-center"
              sx={{
                paddingBottom: "10px",
              }}
            >
              {templeJson["Header"].style == 1 && (
                <img
                  src={"https://durgatemple.org/images/logo.png"}
                  alt="logo"
                  style={{ height: "60px" }}
                />
              )}
            </Box>
          )}
        </Grid>
        <Grid
          item
          xs={4}
          sm={4}
          md={3}
          lg={3}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Grid container spacing={1} className="align-item-center">
            <Grid item xs={4} sm={4} md={4} lg={4} sx={{ overflow: "hidden" }}>
              {hasToken ? (
                loginOptions.map((item, idx) => (
                  <NavItem key={idx} item={item} login={true} />
                ))
              ) : (
                <Button
                  color="inherit"
                  href={`/login?redirect=${encodeURIComponent(currentUrlPath)}`}
                  className="desktop-dropdown-button"
                  sx={{
                    "& .css-1d6wzja-MuiButton-startIcon": { marginRight: 0 },
                  }}
                  startIcon={<Person></Person>}
                >
                  Login
                </Button>
              )}
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <Stack
                direction="row"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <IconButton
                  onClick={() => {
                    handleCartClick();
                  }}
                >
                  <Badge badgeContent={totalCartCount} overlap="rectangular">
                    <img
                      src={
                        process.env.REACT_APP_S3_BASE_URL +
                        "/api/images/cart.png"
                      }
                      alt="cart"
                    />
                  </Badge>
                </IconButton>

                <Search sx={{ color: "whitesmoke" }}></Search>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {isLgDown && (
            <Collapse in={navExpanded} timeout="auto" unmountOnExit>
              <Box className="mobile-nav-container nav-container">
                {menuItems.map((item, idx) => (
                  <NavItem key={idx} item={item} mobile={true} />
                ))}
              </Box>
            </Collapse>
          )}
        </Grid>
      </Grid>
    </AppBar>
  );
};

export default TempleNavbar;
